import { notify } from './toast';
import { getAlgodEndpoint } from '../config';

interface WalletInfo {
  balance: number;
  minBalance: number;
  rekeyTo: string | null;
  hasBalance: boolean;
}

export const formatWalletAddress = (address: string): string => {
  if (!address) return '';
  return `${address.slice(0, 6)}...${address.slice(-7)}`;
};

export const getWalletInfo = async (walletAddress: string): Promise<WalletInfo> => {
  console.log(
    `Fetching wallet ${walletAddress ? formatWalletAddress(walletAddress) : "..."} balance...`
  );

  try {
    const url = `${getAlgodEndpoint()}/accounts/${walletAddress}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Accept": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch wallet info');
    }

    const data = await response.json();
    
    if (data && data.address && Number(data.amount) >= 0) {
      if (String(data.address) === String(walletAddress)) {
        const balance = Number(data.amount);
        const minBalance = Number(data["min-balance"]);
        const rekeyTo = data["auth-addr"] || null;
        const hasBalance = balance - minBalance >= 10000; // Consider having balance if more than 0.01 Algo available

        console.info(
          `Wallet ${formatWalletAddress(walletAddress)} Algo balance:`,
          balance
        );
        console.info(
          `Wallet ${formatWalletAddress(walletAddress)} Algo min balance:`,
          minBalance
        );
        console.info(
          `Wallet ${formatWalletAddress(walletAddress)} Algo available balance:`,
          balance - minBalance
        );
        if (rekeyTo) {
          console.info(
            `Wallet ${formatWalletAddress(walletAddress)} is rekeyed to:`,
            rekeyTo
          );
        }

        return {
          balance,
          minBalance,
          rekeyTo,
          hasBalance
        };
      }
    }

    // Return default values if no valid data
    return {
      balance: 0,
      minBalance: 0,
      rekeyTo: null,
      hasBalance: false
    };
  } catch (error) {
    console.error("Fetch wallet info error:", error);
    notify.error('Failed to fetch wallet information');
    return {
      balance: 0,
      minBalance: 0,
      rekeyTo: null,
      hasBalance: false
    };
  }
};